export default __webpack_public_path__ + "static/media/alert.70db3565.svg";